import { Plugin } from "./plugin/Plugin"
import dotenv from "dotenv"

dotenv.config()

// plugins must be a default export
export default Plugin
